// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EXXn","title":"styles_title__2nJae"};